"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROL_ACCOUNTS = void 0;
/**
 * Canonical control-account nominal codes used by the GL posting engine.
 *
 * These are the accounts every automatic posting debits/credits (accounting-model
 * `.kiro/specs/accounting-model/requirements.md`, Requirements 3 & 5). They MUST
 * exist in the chart of accounts (`DEFAULT_CATEGORIES`) with the categoryType /
 * statementSection asserted by the governance test — otherwise postings would
 * land in the wrong financial statement. Never hardcode these strings in
 * handlers; import from here.
 */
exports.CONTROL_ACCOUNTS = {
    /** Cash at bank — balance-sheet asset. The cash leg of every settlement. */
    bank: '1900',
    /** Service charge debtors control — balance-sheet asset. Receivable leg of
     *  service-charge demands; reconciles to aged debtors. */
    serviceChargeDebtors: '1910',
    /** Trade debtors control — balance-sheet asset. Receivable leg of invoices. */
    tradeDebtors: '1004',
    /** Trade creditors control — balance-sheet liability. Payable leg of bills;
     *  reconciles to aged creditors. */
    creditors: '5001',
    /** Service charge income — profit-loss income. Income leg of demands. */
    serviceChargeIncome: '1001',
};
